import styled from 'styled-components';

import textInputStd from '~/styled/text-input';
import font from '~/styled/font';

export const TextareaWrap = styled.label`
  width: ${({ contentWidth }) => contentWidth};
  height: ${({ contentHeight }) => contentHeight};
  border: 1px solid #EDEDED;
  border-radius: 2px;
  background-color: #FFFFFF;
  transition: all 150ms ease-out;
  position: relative;

  &:focus {
    border-color: #222222;
  }
  
  &:disabled {
    border-color: #EDEDED;
    background-color: #FCFCFC;
  }

  &.left {
    text-align: left;
  }
  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const Textarea = styled.textarea`
  ${textInputStd};
  width: 100%;
  height: 100%;
  resize: none;
`;

export const Count = styled.p`
  padding-bottom: 9px;
  color: #979797;
  ${font.body3};
  font-weight: 400;
  text-align: right;
  position: absolute;
  right: 16px;
  bottom: 1px;
`;
